import type { HomeRow, HomeRows, OVPCarouselType } from '@setplex/tria-api'
import { ContentTypeDefault, OVPBannerType } from '@setplex/tria-api'
import type { ApiHomeRow, ApiHomeRows } from './index.h'
import { ApiHomeRowContentType } from './index.h'

const mapRowContentType = (
  contentType: ApiHomeRow['rowContentType']
): ContentTypeDefault => {
  switch (contentType) {
    case ApiHomeRowContentType.movie:
    case 'movie':
      return ContentTypeDefault.movie
    case ApiHomeRowContentType.tvShow:
    case 'tvShow':
      return ContentTypeDefault.tvshow
    case ApiHomeRowContentType.liveChannel:
    case 'liveChannel':
      return ContentTypeDefault.liveChannel
    case ApiHomeRowContentType.mixed:
    case 'mixed':
    default:
      return ContentTypeDefault.mixed
  }
}

export const formatContentType = mapRowContentType

const mapCarouselType = (
  carouselType: ApiHomeRows['carouselType'] | ApiHomeRows['guestCarouselType']
): OVPCarouselType | null => {
  switch (carouselType) {
    case 'live_channel':
      return OVPBannerType.LIVE_CHANNEL
    case 'content':
      return OVPBannerType.CONTENT
    default:
      return null
  }
}

export const format = ({
  pageH1,
  backgroundImageUrl,
  description,
  imageAltText,
  metaTitle,
  metaDescription,
  carouselId,
  carouselType,
  guestCarouselId,
  guestCarouselType,
  rows,
}: ApiHomeRows): HomeRows => ({
  pageH1: pageH1 || '',
  backgroundImageUrl: backgroundImageUrl || '',
  description: description || '',
  imageAltText: imageAltText || '',
  metaTitle: metaTitle || '',
  metaDescription: metaDescription || '',
  carouselId: carouselId || 0,
  carouselType: mapCarouselType(carouselType),
  guestCarouselId: guestCarouselId || 0,
  guestCarouselType: mapCarouselType(guestCarouselType),
  rows: [...(rows || [])].map(
    (row): HomeRow => ({
      id: row.id,
      rowContentType: mapRowContentType(row.rowContentType || 'mixed'),
      rowEntityType: row.rowEntityType as HomeRow['rowEntityType'],
      rowEntityId: row.rowEntityId,
      sortOrder: row.sortOrder,
      title: row.title || '',
      contentLimit: row.contentLimit,
      filters: row.filters,
      order: row.order,
    })
  ),
})
